import React, { useState, useRef, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FiArrowLeft, FiSend, FiMoreVertical } from "react-icons/fi";
import { BsCheck2, BsCheck2All } from "react-icons/bs";

const mockGroups = {
  1: {
    name: "Tosin Group CTO",
    members: 12,
    messages: [
      { id: 1, sender: "Tosin", text: "Welcome everyone! Let's discuss the new project timeline.", time: "2:30 PM", status: "read" },
      { id: 2, sender: "You", text: "Glad to be here! Looking forward to collaborating.", time: "2:31 PM", status: "read" },
      { id: 3, sender: "Sarah", text: "I've uploaded the initial designs to the shared drive.", time: "2:32 PM", status: "read" },
      { id: 4, sender: "You", text: "Thanks Sarah, I'll review them right away.", time: "2:33 PM", status: "read" },
      { id: 5, sender: "Tosin", text: "Let's schedule a sync for tomorrow to align on priorities.", time: "2:35 PM", status: "read" },
    ],
  },
  2: {
    name: "Baa Moridiyah Coalition",
    members: 45,
    messages: [
      { id: 1, sender: "Baa", text: "Meeting starts at 4pm! Don't forget to bring the reports.", time: "1:15 PM", status: "read" },
      { id: 2, sender: "You", text: "I'll be there with the quarterly analysis.", time: "1:20 PM", status: "read" },
    ],
  },
};

const GroupChatPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [group, setGroup] = useState(mockGroups[id] || mockGroups[1]);
  const chatEndRef = useRef(null);

  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [group.messages]);

  const handleSend = (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    
    const newMessage = {
      id: group.messages.length + 1,
      sender: "You",
      text: message,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      status: "sent"
    };
    
    setGroup({
      ...group,
      messages: [...group.messages, newMessage],
    });
    setMessage("");
  };

  const formatTime = (timeStr) => {
    return timeStr;
  };

  const renderMessageStatus = (status, sender) => {
    if (sender !== "You") return null;
    
    switch(status) {
      case "sent":
        return <BsCheck2 size={14} style={{ marginLeft: 4, color: "rgba(255,255,255,0.7)" }} />;
      case "delivered":
        return <BsCheck2All size={14} style={{ marginLeft: 4, color: "rgba(255,255,255,0.7)" }} />;
      case "read":
        return <BsCheck2All size={14} style={{ marginLeft: 4, color: "#53bdeb" }} />;
      default:
        return <BsCheck2 size={14} style={{ marginLeft: 4, color: "rgba(255,255,255,0.7)" }} />;
    }
  };

  return (
    <div style={styles.chatContainer}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <FiArrowLeft
            size={22}
            style={styles.backIcon}
            onClick={() => navigate("/admin/create-group-chat")}
          />
          <div style={styles.groupInfo}>
            <h2 style={styles.groupName}>{group.name}</h2>
            <p style={styles.members}>{group.members} members • Online</p>
          </div>
        </div>
        <FiMoreVertical size={20} style={styles.menuIcon} />
      </div>

      {/* Messages */}
      <div style={styles.messagesContainer}>
        <div style={styles.messages}>
          {group.messages.map((msg) => (
            <div
              key={msg.id}
              style={{
                ...styles.messageWrapper,
                justifyContent: msg.sender === "You" ? "flex-end" : "flex-start",
              }}
            >
              <div
                style={{
                  ...styles.messageBubble,
                  backgroundColor: msg.sender === "You" ? "#007bff" : "#ffffff",
                  color: msg.sender === "You" ? "#ffffff" : "#333333",
                }}
              >
                {msg.sender !== "You" && (
                  <div style={styles.senderName}>{msg.sender}</div>
                )}
                <div style={styles.messageContent}>
                  <p style={styles.messageText}>{msg.text}</p>
                  <div style={styles.messageMeta}>
                    <span style={styles.messageTime}>{formatTime(msg.time)}</span>
                    {renderMessageStatus(msg.status, msg.sender)}
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div ref={chatEndRef} />
        </div>
      </div>

      {/* Input Bar */}
      <form onSubmit={handleSend} style={styles.inputContainer}>
        <div style={styles.inputWrapper}>
          <input
            type="text"
            placeholder="Type a message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={styles.input}
          />
          <button 
            type="submit" 
            style={{
              ...styles.sendButton,
              backgroundColor: message.trim() ? "#007bff" : "#cccccc",
            }}
            disabled={!message.trim()}
          >
            <FiSend size={18} color="#fff" />
          </button>
        </div>
      </form>
    </div>
  );
};

const styles = {
  chatContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    backgroundColor: "#e5ddd5",
    backgroundImage: "url('data:image/svg+xml,%3Csvg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\"%3E%3Cpath d=\"M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z\" fill=\"%2390c4ed\" fill-opacity=\"0.1\" fill-rule=\"evenodd\"/%3E%3C/svg%3E')",
    fontFamily: "Segoe UI, Helvetica Neue, sans-serif",
    position: "relative",
  },
  
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#007bff",
    color: "#fff",
    padding: "10px 16px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
    zIndex: 100,
  },
  
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  
  backIcon: {
    cursor: "pointer",
    color: "#fff",
    transition: "transform 0.2s ease",
  },
  
  groupInfo: {
    display: "flex",
    flexDirection: "column",
  },
  
  groupName: { 
    margin: 0, 
    fontSize: "16px", 
    fontWeight: "600",
    lineHeight: "1.3",
  },
  
  members: { 
    margin: 0, 
    fontSize: "12px", 
    opacity: 0.85,
    marginTop: "2px",
  },
  
  menuIcon: {
    cursor: "pointer",
    color: "#fff",
    padding: "8px",
  },
  
  messagesContainer: {
    flex: 1,
    overflowY: "auto",
    padding: "10px 0",
  },
  
  messages: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    padding: "0 16px",
  },
  
  messageWrapper: {
    display: "flex",
    marginBottom: "4px",
  },
  
  messageBubble: {
    maxWidth: "70%",
    borderRadius: "8px",
    padding: "8px 12px 6px 12px",
    boxShadow: "0 1px 1px rgba(0,0,0,0.1)",
    position: "relative",
  },
  
  senderName: {
    fontSize: "13px",
    fontWeight: "600",
    marginBottom: "4px",
    color: "#1e88e5",
  },
  
  messageContent: {
    display: "flex",
    flexDirection: "column",
  },
  
  messageText: {
    margin: 0,
    fontSize: "14.5px",
    lineHeight: "1.4",
    wordWrap: "break-word",
  },
  
  messageMeta: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "2px",
  },
  
  messageTime: {
    fontSize: "11px",
    opacity: 0.7,
    marginTop: "1px",
  },
  
  inputContainer: {
    backgroundColor: "#f0f0f0",
    padding: "12px 16px",
    borderTop: "1px solid #e0e0e0",
  },
  
  inputWrapper: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    width: "100%",
    maxWidth: "80%", // Reduced container width from the right
    margin: "0 auto", // Center the container
  },
  
  input: {
    flex: 1,
    border: "none",
    borderRadius: "24px",
    padding: "12px 50px 12px 16px",
    outline: "none",
    fontSize: "15px",
    backgroundColor: "#fff",
    boxShadow: "0 1px 1px rgba(0,0,0,0.08)",
    transition: "all 0.15s ease",
    width: "100%",
    boxSizing: "border-box",
  },
  
  sendButton: {
    border: "none",
    borderRadius: "8px",
    width: "40px",
    height: "40px",
    color: "#fff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    position: "absolute",
    right: "-70px",
    top: "20%",
    transform: "translateY(-50%)",
  },
};

export default GroupChatPage;